import React from 'react';
import PropTypes from 'prop-types';

const PersonalInfoDisplay = ({ informations, multiLine }) => {
    const formattedPhoneNumber = (phone) => {
        if (!phone) {
            return '';
        }
        const areaCode = phone.charAt(0) === '+' ? `(${phone.substr(2, 3)})` : `(${phone.substr(0, 3)})`;
        const phoneNumber =
            phone.charAt(0) === '+'
                ? `${phone.substr(5, 3)}-${phone.substr(8)}`
                : `${phone.substr(3, 3)}-${phone.substr(6)}`;

        return `${areaCode} ${phoneNumber}`;
    };

    return multiLine ? (
        <div className="personalInfo">
            <span>{`${informations.firstname} ${informations.lastname}`}</span>
            <span>{formattedPhoneNumber(informations.phoneNumber)}</span>
            <span>{informations.email}</span>
        </div>
    ) : (
        <span>{`${informations.firstname} ${informations.lastname}`}</span>
    );
};

PersonalInfoDisplay.defaultProps = {
    multiLine: false,
};

PersonalInfoDisplay.propTypes = {
    informations: PropTypes.shape({
        firstname: PropTypes.string.isRequired,
        lastname: PropTypes.string.isRequired,
        phoneNumber: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
    }).isRequired,
    multiLine: PropTypes.bool,
};

PersonalInfoDisplay.displayName = 'PersonalInfoDisplay';

export default PersonalInfoDisplay;



// WEBPACK FOOTER //
// ./src/components/ApplicantInfosForm/PersonalInfoDisplay.jsx